import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import Header from './Header';
import Footer from './Footer';
import RetroTVFuzz from '../effects/RetroTVFuzz';

// Pixel noise animation (original effect)
const noiseAnimation = keyframes`
  0% { opacity: 0.07; }
  50% { opacity: 0.23; }
  100% { opacity: 0.12; }
`;

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  background-color: rgba(245, 247, 250, 0.9); /* Fallback background */
`;

// Original pixelated noise overlay
const PixelNoiseOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000; /* On top of everything */
  pointer-events: none; /* Allow clicks to pass through */
  opacity: ${props => props.opacity}; /* Adjustable opacity */
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E");
  animation: ${noiseAnimation} 2s infinite;
  mix-blend-mode: multiply;
`;

const Main = styled.main`
  flex: 1;
  position: relative;
  z-index: 1; /* Above the background overlays */
  /* Remove any default padding that might create spacing between sections */
  padding: 0;
  margin: 0;
`;

const Layout = ({ children }) => {
  // Each effect can be enabled/disabled and have its opacity adjusted
  const [originalNoiseEnabled, setOriginalNoiseEnabled] = useState(true);
  const [originalNoiseOpacity, setOriginalNoiseOpacity] = useState(0.5); // Reduced opacity to blend better with TV effect
  
  const [retroTVEnabled, setRetroTVEnabled] = useState(true);
  
  return (
    <LayoutContainer className="svg-background">
      <Header />
      <Main>
        {children}
      </Main>
      <Footer />
      
      {/* Original Pixelated noise overlay */}
      {originalNoiseEnabled && (
        <PixelNoiseOverlay opacity={originalNoiseOpacity} />
      )}
      
      {/* New Retro TV Fuzz effect - customize all parameters here */}
      {retroTVEnabled && (
        <RetroTVFuzz 
          // Static noise settings
          staticOpacity={0.025}
          flickerSpeed={3}
          
          // Scan line settings
          showScanLines={true}
          scanLineOpacity={0.25}
          scanLineHeight={2}
          scanLineIntensity={0.05}
          
          // Moving scan line settings
          showMovingScanLine={true}
          movingScanLineOpacity={0.1}
          movingScanLineHeight={5}
          movingScanLineSpeed={8}
          
          // Overall settings
          blendMode="overlay"
          brightSpotFrequency={0.025}
        />
      )}
    </LayoutContainer>
  );
};

export default Layout;